var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$options.MATCH_STATUS_LABELS[_vm.status])?_c('span',{staticClass:"STATUS-BUBBLE",class:{ 'CANCELED' : _vm.status===_vm.$options.MATCH_STATUSES.CANCELED }},[_vm._v("\n  "+_vm._s(_vm.statusLabel)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }